import { Box, Stack, Link as LinkBase } from "@mui/material";
import CustomTable from "components/Table/CustomTable";
import { TABLE_ACTIONS } from "helpers/constants";
import { FC } from "react";
import { Link, useNavigate } from "react-router-dom";

type TemplateListProps = { templates: any[]; organizationId: string };

export const TemplateList: FC<TemplateListProps> = ({
  templates,
  organizationId,
}) => {
  const navigate = useNavigate();
  return (
    <Box>
      <CustomTable
        entities={templates}
        handleActionClick={(action: TABLE_ACTIONS, id: string) => {
          switch (action) {
            case TABLE_ACTIONS.VIEW:
              navigate(
                `/organization/${organizationId}/yearly-curriculum/${id}`,
              );
              break;
            default:
              break;
          }
        }}
        fieldToFilter={"name"}
        columns={[
          {
            id: "name",
            label: "Name",
            value: "name",
          },
          {
            id: "org_id",
            value: (row: any) => (
              <Stack direction="row" spacing={2} alignItems={"center"}>
                <LinkBase
                  sx={{ cursor: "pointer" }}
                  component={Link}
                  to={`/organization/${organizationId}/yearly-curriculum/${row.academic_year_id}`}
                >
                  View
                </LinkBase>
              </Stack>
            ),
          },
          { id: "actions", value: "" },
        ]}
        isSelectable={false}
        allowedMenuItems={[TABLE_ACTIONS.VIEW]}
        extraActionItems={[]}
        idColumn={"academic_year_id"}
      />
    </Box>
  );
};
